module.exports = __webpack_public_path__ + "img/share_san.ea33ff2b.jpg";